import { sectionNames } from "@saleor/intl";
import { asSortParams } from "@saleor/utils/sort";
import { parseQueryString } from "@saleor/utils/urls";
import { parse as parseQs } from "qs";
import React from "react";
import { useIntl } from "react-intl";
import { Route, Routes, useLocation, useParams } from "react-router-dom";

import { WindowTitle } from "../components/WindowTitle";
import {
  CustomerAddressesUrlQueryParams,
  CustomerListUrlQueryParams,
  CustomerListUrlSortField,
  CustomerUrlQueryParams
} from "./urls";
import CustomerAddressesViewComponent from "./views/CustomerAddresses";
import CustomerCreateView from "./views/CustomerCreate";
import CustomerDetailsViewComponent from "./views/CustomerDetails";
import CustomerListViewComponent from "./views/CustomerList";

const CustomerListView: React.FC = () => {
  const location = useLocation();
  const qs = parseQs(location.search.substr(1));
  const params = asSortParams(
    qs,
    CustomerListUrlSortField
  ) as CustomerListUrlQueryParams;

  return <CustomerListViewComponent params={params} />;
};

const CustomerDetailsView: React.FC = () => {
  const location = useLocation();
  const { id } = useParams();
  const params = parseQueryString<CustomerUrlQueryParams>(
    location.search.substr(1)
  );

  return (
    <CustomerDetailsViewComponent id={decodeURIComponent(id)} params={params} />
  );
};

const CustomerAddressesView: React.FC = () => {
  const location = useLocation();
  const { id } = useParams();
  const params = parseQueryString<CustomerAddressesUrlQueryParams>(
    location.search.substr(1)
  );

  return (
    <CustomerAddressesViewComponent
      id={decodeURIComponent(id)}
      params={params}
    />
  );
};

export const CustomerSection: React.FC<{}> = () => {
  const intl = useIntl();

  return (
    <>
      <WindowTitle title={intl.formatMessage(sectionNames.customers)} />
      <Routes>
        <Route path={""} element={<CustomerListView />} />
        <Route path={"add"} element={<CustomerCreateView />} />
        <Route path={":id/addresses"} element={<CustomerAddressesView />} />
        <Route path={":id"} element={<CustomerDetailsView />} />
      </Routes>
    </>
  );
};
